import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import { FunnelEventMarketing } from '@shared/application/marketing/funnel-event-marketing';
import { useTracking } from '@shared/application/tracking.service';

/**
 * Fires `registration_started` once when a funnel entry point mounts, with a
 * `funnel` property supplied by the shared registration tracker.
 *
 * Waits for `router.isReady` so `accessPoint` is hydrated — otherwise the SSG
 * page would record a stale `RegisterMethod.Funnel` before the query resolves.
 */
export const useTrackRegistrationStarted = () => {
  const { isReady } = useRouter();
  const { trackEventRegistration } = useTracking();
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!isReady || hasTracked.current) return;
    hasTracked.current = true;
    trackEventRegistration(FunnelEventMarketing.RegistrationStarted);
  }, [isReady, trackEventRegistration]);
};
